export const GET_ROOM_RATE_REQUEST = 'room/RATE_REQUEST';
export const GET_ROOM_RATE_SUCCESS = 'room/RATE_SUCCESS';
export const GET_ROOM_RATE_ERROR = 'room/RATE_ERROR';

export const getRoomRateRequest = () => ({
  type: GET_ROOM_RATE_REQUEST,
});

export const getRoomRateSuccess = (payload) => ({
  type: GET_ROOM_RATE_SUCCESS,
  payload: payload.room_data,
});

export const getRoomRateError = (payload) => ({
  type: GET_ROOM_RATE_ERROR,
  payload,
});
